// test966
(966 && 0);
